import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/', // pc端
      name: 'home',
      components: {
        pc: () => import('@/views/pc/home.vue'),
        mobile: () => import('@/views/mobile/home-app.vue'),
      },
    },
    {
      path: '/app', //移动端
      name: 'home-app',
      components: {
        pc: () => import('@/views/pc/home.vue'),
        mobile: () => import('@/views/mobile/home-app.vue'),
      },
    },
    {
      path: '/productSeries',
      name: 'productSeries',
      // component: resolve => require(["./views/pc/consult.vue"], resolve),
      components: {
        pc: () => import('@/views/pc/productSeries.vue'),
        mobile: () => import('@/views/pc/productSeries.vue'),
      },
    },
    {
      path: '/scheme',
      name: 'scheme',
      components: {
        pc: () => import('@/views/pc/product.vue'),
        mobile: () => import('@/views/mobile/product.vue'),
      },
    },
    {
      path: '/scheme-app',
      name: 'scheme-app',
      components: {
        pc: () => import('@/views/pc/product.vue'),
        mobile: () => import('@/views/mobile/product.vue'),
      },
    },
    {
      path: '/demonstration',
      name: 'demonstration',
      components: {
        pc: () => import('@/views/pc/productDemonstration.vue'),
        mobile: () => import('@/views/mobile/productDemonstration.vue'),
      },
    },
    {
      path: '/demonstration-app',
      name: 'demonstration-app',
      components: {
        pc: () => import('@/views/pc/productDemonstration.vue'),
        mobile: () => import('@/views/mobile/productDemonstration.vue'),
      },
    },
    {
      path: '/news',
      name: 'news',
      components: {
        pc: () => import('@/views/pc/journalism.vue'),
        mobile: () => import('@/views/mobile/journalism.vue'),
      },
    },
    {
      path: '/news-app',
      name: 'news-app',
      components: {
        pc: () => import('@/views/pc/journalism.vue'),
        mobile: () => import('@/views/mobile/journalism.vue'),
      },
    },
    {
      path: '/newsDetails',
      name: 'news_details',
      components: {
        pc: () => import('@/views/pc/news_details.vue'),
        mobile: () => import('@/views/mobile/news_details-app.vue'),
      },
    },
    {
      path: '/news-details-app',
      name: 'news_details-app',
      components: {
        pc: () => import('@/views/pc/news_details.vue'),
        mobile: () => import('@/views/mobile/news_details-app.vue'),
      },
    },
    {
      path: '/news2',
      name: 'news2',
      component: () => import( /* webpackChunkName: "about" */ './views/news/news2.vue'),
    },
    // {
    //   path: '/news2',
    //   name: 'news2',
    //   component: () => import( /* webpackChunkName: "about" */ './views/news/news2.vue'),
    // },
    {
      path: '/about',
      name: 'about',
      components: {
        pc: () => import('@/views/pc/aboutUs.vue'),
        mobile: () => import('@/views/mobile/aboutUs.vue'),
      },
    },
    {
      path: '/about-app',
      name: 'about-app',
      components: {
        pc: () => import('@/views/pc/aboutUs.vue'),
        mobile: () => import('@/views/mobile/aboutUs.vue'),
      },
    },
    {
      path: '/mtevidence',
      name: 'mtevidence',
      components: {
        pc: () => import('@/views/pc/consult.vue'),
        mobile: () => import('@/views/mobile/consult.vue'),
      },
    },
    {
      path: '/mtevidence-app',
      name: 'mtevidence-app',
      components: {
        pc: () => import('@/views/pc/consult.vue'),
        mobile: () => import('@/views/mobile/consult.vue'),
      },
    },
    {
      path: '/recruitment',
      name: 'recruitment',
      components: {
        pc: () => import('@/views/pc/joinUs.vue'),
        mobile: () => import('@/views/mobile/joinUs.vue'),
      },
    },
    {
      path: '/recruitment-app',
      name: 'recruitment-app',
      components: {
        pc: () => import('@/views/pc/joinUs.vue'),
        mobile: () => import('@/views/mobile/joinUs.vue'),
      },
    },
    {/*采购链接*/
      path: '/purchase',
      name: 'purchase',
      components: {
        pc: () => import('@/views/pc/purchase.vue'),
        mobile: () => import('@/views/mobile/purchase.vue'),
      },
    },
    {/*采购链接*/
      path: '/purchase_mobile',
      name: 'purchase_mobile',
      components: {
        pc: () => import('@/views/pc/purchase.vue'),
        mobile: () => import('@/views/mobile/purchase.vue'),
      },
    }

  ]
})

const VueRouterPush = Router.prototype.push
Router.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch(err => err)
}
router.afterEach((to, from) => {
  document.documentElement.scrollTop = 0;
})


export default  router;
